import {Injectable} from "@angular/core";
import {Title} from "@angular/platform-browser";


const basePageName = "Unisonline"

@Injectable({ providedIn: "root" })
export class TitleWrapperService {
  constructor(
    private title: Title,
  ) {
  }

  setPageName(pageName: string | null) {
    this.title
      .setTitle(
        (pageName != null) ? `${basePageName} - ${pageName}` : basePageName
      );
  }
}
